import { create } from 'zustand';
import { id } from '@/locales/id';
import { en } from '@/locales/en';

export type Locale = 'id' | 'en';
const LOCALES: Record<Locale, Record<string, string>> = { id, en };
const STORAGE_KEY = 'attendance-lang';

interface I18nState {
    locale: Locale;
    setLocale: (locale: Locale) => void;
    t: (key: string, params?: Record<string, string | number>) => string;
}

export const useI18n = create<I18nState>((set, get) => ({
    locale: (typeof window !== 'undefined' ? (localStorage.getItem(STORAGE_KEY) as Locale) : null) || 'id',
    setLocale: (locale) => {
        try { localStorage.setItem(STORAGE_KEY, locale); } catch {}
        set({ locale });
    },
    t: (key, params) => {
        const { locale } = get();
        let str = LOCALES[locale]?.[key] || LOCALES['id']?.[key] || key;
        if (params) {
            for (const [k, v] of Object.entries(params)) {
                str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
            }
        }
        return str;
    },
}));

export function t(key: string, params?: Record<string, string | number>): string {
    return useI18n.getState().t(key, params);
}
